import { create } from 'zustand';
import { SortDirection, TaskBoardSortField, } from './types';
export const TASK_BOARD_COLUMNS = ['OPEN', 'IN_PROGRESS', 'SOLVED'];
export const PAGINATION_CONSTANTS = {
    DEFAULT_LIMIT: 20,
    INCREMENT: 20,
};
/**
 * Default pagination settings for each column
 */
export const DEFAULT_PAGINATION = {
    OPEN: { limit: PAGINATION_CONSTANTS.DEFAULT_LIMIT, totalCount: 0, isLoading: false },
    IN_PROGRESS: { limit: PAGINATION_CONSTANTS.DEFAULT_LIMIT, totalCount: 0, isLoading: false },
    SOLVED: { limit: PAGINATION_CONSTANTS.DEFAULT_LIMIT, totalCount: 0, isLoading: false },
};
/**
 * Default filters
 */
export const DEFAULT_FILTERS = {
    tagIDs: [],
    teams: [],
    vendorIDs: [],
    assignedToProfileIDs: [],
    createdByProfileIDs: [],
    priorities: [],
    entityTypes: [],
    dueDateStart: undefined,
    dueDateEnd: undefined,
    createdDateStart: undefined,
    createdDateEnd: undefined,
    sortBy: TaskBoardSortField.DUE_DATE,
    sortDirection: SortDirection.ASC,
};
/**
 * Initialize default column state
 */
const initializeDefaultColumns = () => {
    return {
        OPEN: [],
        IN_PROGRESS: [],
        SOLVED: [],
    };
};
/**
 * Initialize default pagination state
 */
const initializeDefaultPagination = () => {
    return {
        OPEN: { ...DEFAULT_PAGINATION.OPEN },
        IN_PROGRESS: { ...DEFAULT_PAGINATION.IN_PROGRESS },
        SOLVED: { ...DEFAULT_PAGINATION.SOLVED },
    };
};
/**
 * Create the task board store with Zustand - focused only on state management
 */
export const useTaskBoardStore = create((set, get) => {
    return {
        // Initial state
        application: null,
        columns: initializeDefaultColumns(),
        pagination: initializeDefaultPagination(),
        availableTags: [],
        vendors: [],
        filters: DEFAULT_FILTERS,
        isLoading: false,
        error: null,
        getTask: (taskId) => {
            const { columns } = get();
            for (const column of TASK_BOARD_COLUMNS) {
                const task = columns[column].find((t) => t.id === taskId);
                if (task)
                    return task;
            }
            return null;
        },
        // Setup actions
        setApplication: (application) => set({ application }),
        // State update actions
        setLoading: (isLoading) => set({ isLoading }),
        setError: (error) => set({ error }),
        setTags: (tags) => set({ availableTags: tags }),
        setVendors: (vendors) => set({ vendors }),
        setLimit: (column, limit) => set((state) => ({
            pagination: {
                ...state.pagination,
                [column]: {
                    ...state.pagination[column],
                    limit,
                    isLoading: true,
                },
            },
        })),
        // Column and ticket management
        setColumnTasks: (column, tasks, totalCount) => set((state) => ({
            columns: {
                ...state.columns,
                [column]: tasks,
            },
            pagination: {
                ...state.pagination,
                [column]: {
                    ...state.pagination[column],
                    totalCount,
                    isLoading: false,
                },
            },
        })),
        setAllColumns: (columnsData) => set({ columns: columnsData }),
        // Filter actions
        setFilters: (partialFilters) => {
            set({
                filters: {
                    ...get().filters,
                    ...partialFilters,
                },
            });
        },
        resetFilters: () => set({ filters: DEFAULT_FILTERS }),
        // Error handling
        clearError: () => set({ error: null }),
    };
});
//# sourceMappingURL=store.js.map